import request from "../utils/request";
const diagnosisApi = {
    diagList: '/diag',
}
export function getDiagListApi(params) {
    return request({
        url: diagnosisApi.diagList,
        method: 'get',
        params
    })
}
export function updateDiagApi(parameter) {
    return request({
        url: diagnosisApi.diagList,
        method: 'put',
        data: parameter,
    });
}

export function addDiagApi(parameter) {
    return request({
        url: diagnosisApi.diagList,
        method: 'post',
        data: parameter,
    });
}
export function deleteDiagApi(params) {
    return request({
        url: diagnosisApi.diagList,
        method: 'delete',
        params
    });
}